module.exports = __webpack_public_path__ + "img/default.d84f50a4.png";